// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
const initialState = {
  boothId: '',
  boothSecret: '',
  notifications: 'off',
  cbxKey: '',
  cbxSecret: '',
  advancedSectionHidden: false
};

export const SET_SETTINGS_SAGA = 'settings/set-settings-saga';
export const SETTINGS_UPDATED = 'settings/set-settings-success';

export function setSettings(settings, props) {
  return { type: SET_SETTINGS_SAGA, data: settings, props };
}

export interface SettingsState {
  boothId: string;
  boothSecret: string;
  notifications: string;
  advancedSectionHidden: boolean;
}

// Reducer
export function settingsReducer(state: SettingsState = initialState, action: any = {}): SettingsState {
  switch (action.type) {
    case SETTINGS_UPDATED: {
      return { ...state, ...action.data };
    }
    default: {
      return state;
    }
  }
}
